export const eAnimationNames = {
  EAN_ANTISIPATOR: 'FT.anticipation',
  EAN_POPUP_SHINE: 'pop_up_shine',
};

export const eBigWinAnimationNames = {
  START: 'BW',
  IDLE: 'BW.loop',
};

export const eMegaWinAnimationNames = {
  START: 'MW',
  IDLE: 'MW.loop'
};

export const eJackpotWinAnimationNames = {
  IDLE: 'JP.loop',
  START: 'JP',
};
